import React from "react";

const SitemapBanner = () => {
  return (
    <div className="sitemap-banner">
      <section className="inner_page_sitemap bg-light">
        <div className="container">
          <div className="sitemap-search-container">
            <div className="sitemap-search-content">
              <h1 className="sitemap-search-title text-center">
                Site Map
                
              </h1>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SitemapBanner;
